import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [state, setState] = useState("checking");

    useEffect(() => {
        if (!sessionId) {
            setState("error");
            return;
        }
        let attempts = 0;
        const poll = async () => {
            try {
                const { data } = await api.get(`/payments/status/${sessionId}`);
                if (data.payment_status === "paid") {
                    setState("paid");
                    return;
                }
            } catch (e) {
                /* keep polling briefly */
            }
            attempts += 1;
            if (attempts < 15) setTimeout(poll, 2000);
            else setState("pending");
        };
        poll();
    }, [sessionId]);

    return (
        <div className="flex min-h-screen items-center justify-center px-6" data-testid="payment-success-page">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                className="max-w-lg text-center"
            >
                {state === "checking" && (
                    <>
                        <p className="font-cinzel animate-pulse text-2xl text-[#f3e5ab]" data-testid="payment-status-text">
                            Sealing your place in the garden...
                        </p>
                    </>
                )}
                {state === "paid" && (
                    <>
                        <p className="font-cinzel text-xs tracking-[0.4em] text-[#b89860] uppercase">It is done</p>
                        <h1 className="font-cinzel mt-6 text-4xl text-[#f3e5ab]" data-testid="payment-status-text">
                            Your Copy Is Reserved
                        </h1>
                        <p className="font-cormorant mt-6 text-lg italic leading-relaxed text-[#a3b899]">
                            Thank you. Your first edition will find you when the unveiling comes.
                            You are now part of the remembering.
                        </p>
                    </>
                )}
                {(state === "pending" || state === "error") && (
                    <>
                        <h1 className="font-cinzel text-3xl text-[#f3e5ab]" data-testid="payment-status-text">
                            {state === "pending" ? "Almost There" : "Something Is Unclear"}
                        </h1>
                        <p className="font-cormorant mt-6 text-lg italic text-[#a3b899]">
                            Your payment is still being confirmed. If you were charged, your copy is safe —
                            the garden does not lose its own.
                        </p>
                    </>
                )}
                <Link
                    to="/"
                    data-testid="return-home-link"
                    className="btn-eden mt-10 inline-block rounded-sm bg-transparent px-8 py-4 text-xs text-[#d4af37]"
                >
                    Return to the Garden
                </Link>
            </motion.div>
        </div>
    );
}
